import { useQuery } from '@tanstack/react-query';
import { listHelpArticles } from '@/lib/help-api';
import type { HelpAudience } from '@/lib/schemas';

export const helpKeys = {
  articles: (audience: HelpAudience) => ['help', audience] as const,
};

/**
 * The guide changes when a feature ships, not while somebody is reading it, so this is cached for an
 * hour rather than the app-wide 30 seconds. A refetch on every navigation back to the guide would be
 * a request per visit for content that is identical between deploys.
 */
export function useHelpArticles(audience: HelpAudience) {
  return useQuery({
    queryKey: helpKeys.articles(audience),
    queryFn: () => listHelpArticles(audience),
    staleTime: 60 * 60 * 1000,
  });
}
